import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var BuildingsSVG = function BuildingsSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.72,6.82,14.36,2.07a1,1,0,0,0-.93.11A1,1,0,0,0,13,3v9H6a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V8.69A2,2,0,0,0,26.72,6.82ZM12,26H9a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm8,7a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Zm4,0a1,1,0,0,1-2,0V12a1,1,0,0,1,2,0Z"
  }));
};
BuildingsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BuildingsSVG);